import React, { useRef, useEffect, useState, memo } from "react";
import {
  StyleSheet,
  View,
  Animated,
  TouchableOpacity,
  Modal,
} from "react-native";
import Text from "@components/AppText";
import CloseIcon from "@assets/svg/CloseIcon";
import t from "@constants/localization";
import ApplyCoupon from "./AvailableCoupon";

const PATH = "screens/CouponScreen/CouponToBeApplied";

const CouponToBeApplied = memo(
  ({
    activeCoupon = null,
    handleActiveCoupon = () => {},
    userId = "",
    handleToggleLoading = () => {},
  }) => {
    const [mainWrapperHeight, setMainWrapperHeight] = useState(300);
    const transformVertical = useRef(new Animated.Value(300));
    const [visible, setVisible] = useState(false);

    useEffect(() => {
      if (activeCoupon !== null && visible === false) {
        setVisible(true);
        Animated.timing(transformVertical.current, {
          toValue: 0,
          duration: 300,
          useNativeDriver: true,
        }).start();
      }
    }, [activeCoupon]);

    const closeModal = () => {
      Animated.timing(transformVertical.current, {
        toValue: mainWrapperHeight,
        duration: 300,
        useNativeDriver: true,
      }).start();
      handleActiveCoupon(null);
      setVisible(false);
    };

    return (
      <Modal transparent visible={visible}>
        <View
          style={styles.container}
          onLayout={({
            nativeEvent: {
              layout: { x, y, width, height },
            },
          }) => {
            setMainWrapperHeight(height);
          }}
        >
          <Animated.View
            style={[
              styles.wrapper,
              { transform: [{ translateY: transformVertical.current }] },
            ]}
          >
            <View style={[styles.beLikeRow, styles.headContainer]}>
              <View>
                <Text
                  style={{
                    color: "rgba(0, 0, 0, .56)",
                  }}
                  fontType="head3"
                >
                  {t(`${PATH}/offerDetails`)}
                </Text>
              </View>
              <TouchableOpacity
                onPress={() => {
                  closeModal();
                }}
              >
                <CloseIcon />
              </TouchableOpacity>
            </View>
            <ApplyCoupon
              visibleInModal
              coupon={activeCoupon}
              userId={userId}
              handleToggleLoading={handleToggleLoading}
            />

            <View style={styles.termsContainer}>
              {activeCoupon &&
                activeCoupon.coupon_terms &&
                activeCoupon.coupon_terms.length > 0 && (
                  <View style={{ paddingHorizontal: 10 }}>
                    <Text bold>{t(`${PATH}/couponTnC`)}</Text>
                  </View>
                )}
              <View style={styles.terms}>
                {activeCoupon &&
                  activeCoupon.coupon_terms &&
                  activeCoupon.coupon_terms.map((term) => (
                    <View style={styles.term} key={term}>
                      <Text
                        style={{
                          color: "rgba(0, 0, 0, .56)",
                        }}
                      >
                        • {term}
                      </Text>
                    </View>
                  ))}
              </View>
            </View>
          </Animated.View>
        </View>
      </Modal>
    );
  },
);

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  container: {
    flex: 1,
    ...StyleSheet.absoluteFill,
    backgroundColor: "rgba(0, 0, 0, 0.56)",
  },
  wrapper: {
    backgroundColor: "#fff",
    position: "absolute",
    bottom: 0,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    width: "100%",
  },
  headContainer: {
    marginVertical: 10,
    paddingHorizontal: 20,
    justifyContent: "space-between",
    marginTop: 20,
  },
  termsContainer: {
    marginVertical: 10,
  },
  terms: {
    paddingHorizontal: 10,
    marginVertical: 10,
  },
  term: {
    marginVertical: 5,
  },
});

export default CouponToBeApplied;
